export const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:3100";

export const DEVICE_STATUSES = ["assembly", "packaging", "stock", "delivered", "defective"];

export const STATUS_TR = {
  assembly: "Montaj",
  packaging: "Paketleme",
  stock: "Stok",
  delivered: "Teslim",
  defective: "Arızalı",
};

export const STATUS_COLORS = {
  assembly: "#3498db",
  packaging: "#f39c12",
  stock: "#9b59b6",
  delivered: "#2ecc71",
  defective: "#e74c3c",
};

export const STATUS_APPEARANCE = {
  assembly: "inprogress-subtle",
  packaging: "warning-subtle",
  stock: "default-subtle",
  delivered: "success-subtle",
  defective: "danger-subtle",
};

export const RP_SERIES = {
  good: "#2ecc71",
  rejected: "#e74c3c",
  rework: "#f39c12",
};

export const RP_CHART_MONO = "#3498db";

export const RP_DONUT_TEALS = [
  "#3498db",
  "#2ecc71",
  "#f39c12",
  "#e74c3c",
  "#9b59b6",
  "#1abc9c",
  "#d35400",
  "#34495e",
];

/** Formal corporate blue palette for production charts */
export const RP_PRODUCTION_TEALS = [
  "#4472C4",
  "#2E75B6",
  "#3A6FB5",
  "#4F7FBF",
  "#3669A5",
  "#5285C4",
  "#4579B8",
  "#3369A5",
];
